import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Home from "./pages/Home";
import About from "./pages/About";
// import Publications from "./pages/Publications";
// import Projects from "./pages/Projects";
import Events from "./pages/Events";
// import Gallery from "./pages/Gallery";
// import Support from "./pages/Support";
// import SchoolTeam from "./pages/SchoolTeam";
import YonetimKurulu from "./pages/YonetimKurulu";
import GenelBaskan from "./pages/GenelBaskan";
import KolektifAvrupa from "./pages/KolektifAvrupa";
import KolektifGenclik from "./pages/KolektifGenclik";
import FAQ from "./pages/FAQ";
// import Partners from "./components/Partners";
import Discounts from "./pages/Discounts";
import Contact from "./pages/Contact";
import { ProtectedRoute } from "./components/ProtectedRoute";
import Navbar from "./components/Navbar";
import NotFound from "./pages/NotFound";
import SingleBlogPost from "./pages/SingleBlogPost";
import Login from "./pages/Login";
import Register from "./pages/Register";
import { SEO } from "./components/SEO";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}

const Router = () => {
  return (
    <>
      <Navbar />
      <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <SEO
                title="Kolektif Oluşum - Türkiye'nin ve Avrupa'nın En Büyük Öğrenci Ağı"
                description="Öğrenci etkinlikleri, gençlik projeleri, networking imkanları, kariyer gelişimi, staj tecrübeleri ve daha fazlası"
              />
              <Home />
            </>
          }
        />
        <Route
          path="/hakkimizda"
          element={
            <>
              <SEO
                title="Hakkımızda - Kolektif Oluşum"
                description="Kolektif Oluşum'un misyonu, vizyonu ve değerleri hakkında bilgi edinin"
              />
              <About />
            </>
          }
        />
        <Route
          path="/ekibimiz/genel-baskan"
          element={
            <>
              <SEO
                title="Genel Başkan - Kolektif Oluşum"
                description="Kolektif Oluşum Genel Başkanı hakkında bilgi edinin"
              />
              <GenelBaskan />
            </>
          }
        />
        <Route
          path="/ekibimiz/yonetim-kurulu"
          element={
            <>
              <SEO
                title="Yönetim Kurulu - Kolektif Oluşum"
                description="Kolektif Oluşum Yönetim Kurulu üyeleri ve görevleri"
              />
              <YonetimKurulu />
            </>
          }
        />
        <Route
          path="/ekibimiz/kolektif-avrupa"
          element={
            <>
              <SEO
                title="Kolektif Avrupa - Kolektif Oluşum"
                description="Kolektif Oluşum'un Avrupa'daki faaliyetleri ve ekip üyeleri"
              />
              <KolektifAvrupa />
            </>
          }
        />
        {/* <Route path="/ekibimiz/kolektif-liseler" element={<Partners />} /> */}
        {/* <Route
          path="/ekibimiz/kolektif-liseler/:schoolId"
          element={
            <>
              <SEO
                title="Kolektif Liseler - Kolektif Oluşum"
                description="Kolektif Oluşum'un lise öğrenci ağı ve ekip üyeleri"
              />
              <SchoolTeam />
            </>
          }
        /> */}
        <Route
          path="/ekibimiz/kolektif-genclik"
          element={
            <>
              <SEO
                title="Kolektif Gençlik - Kolektif Oluşum"
                description="Kolektif Oluşum'un gençlik ağı ve ekip üyeleri"
              />
              <KolektifGenclik />
            </>
          }
        />
        {/* <Route path="/yayinlar" element={<Publications />} /> */}
        {/* <Route
          path="/projeler"
          element={
            <>
              <SEO
                title="Projeler - Kolektif Oluşum"
                description="Kolektif Oluşum'un gerçekleştirdiği ve desteklediği projeler"
              />
              <Projects />
            </>
          }
        /> */}
        <Route
          path="/etkinliklerimiz"
          element={
            <>
              <SEO
                title="Etkinliklerimiz - Kolektif Oluşum"
                description="Kolektif Oluşum'un düzenlediği ve katıldığı etkinlikler"
              />
              <Events />
            </>
          }
        />
        <Route
          path="/etkinliklerimiz/:postId"
          element={
            <>
              <SEO
                title="Etkinlik Detayı - Kolektif Oluşum"
                description="Kolektif Oluşum etkinlik detayları"
              />
              <SingleBlogPost />
            </>
          }
        />
        {/* <Route path="/galeri" element={<Gallery />} /> */}
        {/* <Route
          path="/destek-ol"
          element={
            <>
              <SEO
                title="Destek Ol - Kolektif Oluşum"
                description="Kolektif Oluşum'a destek olmak için yapabilecekleriniz"
              />
              <Support />
            </>
          }
        /> */}
        <Route
          path="/sss"
          element={
            <>
              <SEO
                title="Sıkça Sorulan Sorular - Kolektif Oluşum"
                description="Kolektif Oluşum hakkında sıkça sorulan sorular ve cevapları"
              />
              <FAQ />
            </>
          }
        />
        <Route
          path="/iletisim"
          element={
            <>
              <SEO
                title="İletişim - Kolektif Oluşum"
                description="Kolektif Oluşum ile iletişime geçin"
              />
              <Contact />
            </>
          }
        />
        <Route
          path="/giris-yap"
          element={
            <>
              <SEO
                title="Giriş Yap - Kolektif Oluşum"
                description="Kolektif Oluşum hesabınıza giriş yapın"
              />
              <Login />
            </>
          }
        />
        <Route
          path="/uye-ol"
          element={
            <>
              <SEO
                title="Üye Ol - Kolektif Oluşum"
                description="Kolektif Oluşum'a üye olun"
              />
              <Register />
            </>
          }
        />
        <Route
          path="/indirimler"
          element={
            <ProtectedRoute>
              <SEO
                title="İndirimler - Kolektif Oluşum"
                description="Kolektif Oluşum üyelerine özel indirimler"
              />
              <Discounts />
            </ProtectedRoute>
          }
        />
        <Route
          path="*"
          element={
            <>
              {/* <SEO
                title="Sayfa Bulunamadı - Kolektif Oluşum"
                description="Aradığınız sayfa bulunamadı"
              /> */}
              <NotFound />
            </>
          }
        />
      </Routes>
    </>
  );
};

export default Router;
